angular.module('leanlaw').directive('alertsContainer', [function () {
  return {
    replace: true,
    restrict: "E",
    scope: {},
    template: require('./views/alerts-container.html'),
    link: function link(scope, element, attrs) {},
    controller: ['$scope', '$rootScope', 'alerts', '$timeout', ($scope, $rootScope, alerts, $timeout) => {
      function updateAlerts() {
        $timeout(() => {
          $scope.alerts = alerts.getAlerts();
        }, 1);
      }
      $rootScope.$on("$ll-alert-remove", updateAlerts);
      $rootScope.$on("$ll-alert-add", updateAlerts);
    }]
  };
}]);